<button style="float: right; top: -24px; right: -24px" mat-icon-button mat-dialog-close="">
    <mat-icon class="close-icon">close</mat-icon>
</button>
<mat-dialog-content>{{'Dialog.RestorePasswordDialog.PasswordRecoveryMessage' | translate}}</mat-dialog-content>
